import React, { useEffect, useState } from 'react';

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';

import styles from './Categories.module.css';

ChartJS.register(ArcElement, Tooltip, Legend);

// const chartRef = useRef(null);

// const data = {
//   labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
//   datasets: [
//     {
//       label: '# of Votes',
//       data: [12, 19, 3, 5, 2, 3],
//       backgroundColor: [
//         'rgba(255, 99, 132, 0.2)',
//         'rgba(54, 162, 235, 0.2)',
//         'rgba(255, 206, 86, 0.2)',
//         'rgba(75, 192, 192, 0.2)',
//         'rgba(153, 102, 255, 0.2)',
//         'rgba(255, 159, 64, 0.2)',
//       ],
//       borderColor: [
//         'rgba(255, 99, 132, 1)',
//         'rgba(54, 162, 235, 1)',
//         'rgba(255, 206, 86, 1)',
//         'rgba(75, 192, 192, 1)',
//         'rgba(153, 102, 255, 1)',
//         'rgba(255, 159, 64, 1)',
//       ],
//       borderWidth: 1,
//     },
//   ],
// };

const catStyles = [
  {
    color: '#29B6F6',
    fontSize: '5rem',
    fontWeight: '700',
    marginBottom: '-20px',
  },
  {
    color: '#FFCA28',
    fontSize: '4rem',
    fontWeight: '700',
    marginBottom: '-20px',
  },
  {
    color: '#9CCC65',
    fontSize: '3rem',
    fontWeight: '700',
    marginBottom: '10px',
  },
  {
    color: '#FF7043',
    fontSize: '2.5rem',
    fontWeight: '700',
    marginBottom: '10px',
  },
  {
    color: '#F48FB1',
    fontSize: '2rem',
    fontWeight: '700',
    marginBottom: '20px',
  },
  {
    color: '#DED9C4',
    fontSize: '1.55rem',
    fontWeight: '700',
  },
  {
    color: '#DED9C4',
    fontSize: '1.45rem',
    fontWeight: '700',
  },
  {
    color: '#DED9C4',
    fontSize: '1.35rem',
    fontWeight: '700',
  },
  {
    color: '#DED9C4',
    fontSize: '1.25rem',
    fontWeight: '700',
  },
  {
    color: '#DED9C4',
    fontSize: '1.15rem',
    fontWeight: '700',
  },
];

const tChartData = [
  { category: '#1', count: 0 },
  { category: '#2', count: 0 },
  { category: '#3', count: 0 },
  { category: '#4', count: 0 },
  { category: '#5', count: 0 },
];

const options = {
  // legend: {
  //    labels: {
  //       color: 'white' //set your desired color
  //    }}
  plugins: {
    tooltip: {
      enabled: true,
      intersect: false
    },
    legend: {
      display: false,
     align: "start",
      position: "top",
      labels: {
        font: {family: "'Source Sans Pro', sans-serif", weight: "bold", size: 10, lineHeight: 1.5},
        color: "#FEF9EF",
        pointStyle: "circle",
        usePointStyle: true
        // padding: "50px"
      }
    }
  }
  };

const data = {
  labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
  datasets: [
    {
      label: '# of Votes',
      data: [12, 19, 3, 5, 2, 3],
      backgroundColor: [
        '#151515',
        '#151515',
        '#151515',
        '#151515',
        '#151515',
      ],
      borderColor: [
        '#151515',
        '#151515',
        '#151515',
        '#151515',
        '#151515',
      ],
      borderWidth: 8,
    },
  ],
};

const Categories = (props) => {
  // const [catMode, setCatMode] = useState();
  const [chartData, setChartData] = useState(data);
  const [snCat, setSnCat] = useState([]);
  const [snTopCat, setSnTopCat] = useState([]);
  const [snTopFiveCat, setSnTopFiveCat] = useState([]);

  useEffect(() => {
    setSnCat(props.categoriesArray);
    setSnTopCat(props.categoriesArray.slice(0, 13));
    setSnTopFiveCat(props.categoriesArray.slice(0, 5));
  }, [props.categoriesArray]);

  useEffect(() => {
    // console.log(snTopFiveCat);

    const gotLabels = [];
    const gotData = [];
    snTopFiveCat.map((cat) => gotLabels.push(cat.category));
    snTopFiveCat.map((cat) => gotData.push(cat.count));
    gotLabels.slice(0, 5);
    gotData.slice(0, 5);

    const data = {
      labels: gotLabels,
      // labels: ["#1", "test2", "test3", "test4", "test5"],
      datasets: [
        {
          label: 'top categories',
          color: '#fff',
          data: gotData,
          backgroundColor: [
            '#29B6F6',
            '#FFCA28',
            '#9CCC65',
            '#FF7043',
            '#F48FB1',
          ],
          borderColor: [
            '#151515',
            '#151515',
            '#151515',
            '#151515',
            '#151515',
          ],
          borderWidth: 8,
        },
      ],
    };

    setChartData(data);
  }, [snTopFiveCat]);

  const createChartData = (snTopCat) => {
    console.log('topTen', snTopCat);
    const data = {
      labels: ['#1', 'test2', 'test3', 'test4', 'test5'],
      datasets: [
        {
          label: '# of Votes',
          data: [1, 2, 3, 4, 5],
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(255, 159, 64, 0.2)',
          ],
          borderColor: [
            'rgba(255, 99, 132, 1)',
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(153, 102, 255, 1)',
            'rgba(255, 159, 64, 1)',
          ],
          borderWidth: 1,
        },
      ],
    };
    return data;
  };

  // const styleGetter = i => {
  //   return {
  //     color: 'blue',
  //     fontSize: 1rem
  //   };
  // };

  // const createChartData = (snTopCat) => {

  //   let cData = {
  //     datasets: [{
  //         data: [snTopCat[0].category, snTopCat[1].category, snTopCat[2].category, snTopCat[3].category, snTopCat[4].category]
  //     }],
  //     labels: [
  //         snTopCat[0].count,
  //         snTopCat[1].count,
  //         snTopCat[2].count,
  //         snTopCat[3].count,
  //         snTopCat[4].count
  //     ]
  // };

  // return cData;

  // };

  return (
    <div className={styles.categoriesContainer}>
      <h2>top categories:</h2>
      <div className={styles.pieDiv}>
        <Pie data={chartData} options={options} />
      </div>

      <div className={styles.listDiv}>
        <ul>
          {snTopCat.map((cat, i) => (
            <li key={cat.category}>
              <span className={styles.catName} style={catStyles[i]}>
                {cat.category}
              </span>
              <span className={styles.catCount}>{cat.count}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Categories;
